import { disableDocument } from "~/context/Documents/application/disableDocument";
import { getDocumentByDocumentUidAndType } from "~/context/Documents/application/getDocumentByDocumentId";
import { getFullDocumentByIdCompanyAndType } from "~/context/Documents/application/getFullDocumentByIdCompanyAndType";
import { listBestMatchDocumentsForMovement, listDocumentsByCompanyAndCriteria, listDocumentsByCompanyTypeYearMonth, listDocumentsFullByCompanyAndCriteria, listDocumentsFullByCompanyYearAndCriteria, listDocumentsFullByCompanyYearMonthAndCriteria, listDocumentsFullRepositoryByCompanySearchAndClient, listDocumentsFullRepositoryByCompanySearchAndProvider, listDocumentsFullRepositoryByCompanySearchProviderAndCriteria, listExpensesAsDocumentsFullByCompanyAndCriteria, listFullDocumentsByCompanyEmployeeAndCriteria, listFullDocumentsCreditsByCompanyProviderAndCriteria, listFullDocumentsInvoicesBillsByCompanyProviderAndCriteria, listFullOutcomeDocumentsByCompanyCollaboratorAndCriteria, listFullOutcomeDocumentsByCompanyEmployeeAndCriteria, listFullOutcomeDocumentsByCompanyProviderAndCriteria, listIncomeDocumentsByCompanyTypeYearMonth, listNearDocumentsForDocument, listNearDocumentsForMovement, listSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria, listTop10FutureIncomeDocuments, listTop10FutureIncomeInvoices, listTop10FutureOutcomeDocuments, listTop10FutureOutcomeInvoices, listTop10OverdueOutcomeInvoices, listTop10PendingIncomeInvoices } from "~/context/Documents/application/listDocuments";
import { listDocumentsByCompanyDistanceAndCriteria } from "~/context/Documents/application/listDocuments";
import { listDocumentsByCompanyDistanceAndCriteriaWithMovement } from "~/context/Documents/application/listDocuments";
import { listFullDocumentsByCompanyAndCriteria } from "~/context/Documents/application/listDocuments";
import { listFullIncomeDocumentsByCompanyAndCriteria } from "~/context/Documents/application/listDocuments";
import { listFullIncomeDocumentsByCompanyClientAndCriteria } from "~/context/Documents/application/listDocuments";
import { listFullOutcomeDocumentsByCompanyAndCriteria } from "~/context/Documents/application/listDocuments";
import { listDocumentsFullRepositoryByCompanyAndSearch } from "~/context/Documents/application/listDocuments";
import { saveExpectedPayDate } from "~/context/Documents/application/saveExpectedPayDate";
import { Document } from "~/context/Documents/domain/Document";
import { Movement } from "~/context/Movements/domain/Movement";
import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { Filter } from "~/context/Shared/domain/criteria/Filter";
import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { Dependencies } from "~/context/Shared/infrastructure/Dependencies";


export async function useBestMatchesDocumentsForMovement(companyId: string, movementId: string): Promise<VectiResult> {
  console.log("dentro de useBestMatchesForMovement: " + companyId + " movementId: " + movementId);
  const tolerance = 0; // Valor por defecto, se puede ajustar según sea necesario
  const retDocuments = await listBestMatchDocumentsForMovement(Dependencies.getInstance().getDocumentRepository(), companyId, movementId, tolerance);
  console.log("retDocuments #-->: ", JSON.stringify(retDocuments.type?.length));
  return retDocuments;
}

export async function useNearDocumentsPageForMovement(companyId:string, movementId: string, movementAmount:number, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useDocumentsForMovement: " + companyId + " movementId: " + movementId +  " movementAmount: " + movementAmount + " pageNumber:" + pageNumber + " pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("document_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  if(movementAmount>0){
    /*
    const incomeFilter = new Filter("document_original_type", "IN", ExpenseDomain.INFLOWS.join(","));
    arrayFilters.push(incomeFilter);
    const incomeInvoiceFilter = new Filter("document_origin", "=", 'LIBROVENTA');
    arrayFilters.push(incomeInvoiceFilter);
    */
    const incomeFilter = new Filter("show_inflows", "===", "true");
    arrayFilters.push(incomeFilter);
  }else if(movementAmount<0){
    /*
    const outcomeFilter = new Filter("document_total_amount", "IN", ExpenseDomain.OUTFLOWS.join(","));
    arrayFilters.push(outcomeFilter);
    */
    const outcomeFilter = new Filter("show_outflows", "===", "true");
    arrayFilters.push(outcomeFilter);

  }

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retDocuments = await listNearDocumentsForMovement(Dependencies.getInstance().getDocumentRepository(), companyId, movementId, criteria);
  console.log("retDocuments #-->: ", JSON.stringify(retDocuments.type?.content?.length));  
  return retDocuments;
}

export async function useNearDocumentsPageForDocument(companyId:string, documentId: string, type: string, pageNumber:number, pageSize:number ): Promise<VectiResult> {
  console.log("dentro de useDocumentsForDocument: " + companyId + " documentId: " + documentId + ", type:" + type +", pageNumber:" + pageNumber + ", pageSize:" + pageSize);  
  const defaultFilter = new Filter("company_uid", "=", companyId);
  const balanceFilter = new Filter("document_balance", ">", "0");

  let arrayFilters = [];
  arrayFilters.push(defaultFilter);
  arrayFilters.push(balanceFilter);

  const criteria = new Criteria(pageNumber, pageSize, arrayFilters);
  const retDocuments = await listNearDocumentsForDocument(Dependencies.getInstance().getDocumentRepository(), companyId, documentId, type, criteria);
  console.log("retDocuments #-->: ", JSON.stringify(retDocuments.type?.content?.length));  
  return retDocuments;
}

export function useDocumentFullCompanyCriteria(companyId: string, criteria: Criteria) {
  const retDocuments = listDocumentsFullByCompanyAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, criteria);
  return retDocuments;
}

export function useExpenseAsDocumentFullCompanyCriteria(companyId: string, criteria: Criteria) {
  const retExpenses = listExpensesAsDocumentsFullByCompanyAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, criteria);
  return retExpenses;
}



export function useDocumentCompanyCriteria(companyId: string, criteria: Criteria) {
  const retDocuments = listDocumentsByCompanyAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, criteria);
  return retDocuments;
}

export function useDocument(companyId: string, documentId: string, document_type: string) {
  console.log("dentro de useDocument: " + documentId + " document_type:" + document_type);
  const retDocument = getDocumentByDocumentUidAndType(Dependencies.getInstance().getDocumentRepository(), companyId, documentId, document_type);
  return retDocument;
}

export function useDocumentCompanyDistanceCriteria(companyId: string, movementId: string, criteria: Criteria) {
  const retDocument = listDocumentsByCompanyDistanceAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, movementId, criteria);
  return retDocument;
}

export function useDocumentCompanyDistanceCriteriaWithMovement(companyId: string, movement: Movement, criteria: Criteria) {
  const retDocument = listDocumentsByCompanyDistanceAndCriteriaWithMovement(Dependencies.getInstance().getDocumentRepository(), companyId, movement, criteria);
  return retDocument;
}


export function useFullDocumentCompanyCriteria(companyId: string, criteria: Criteria) {
  const retDocuments = listFullDocumentsByCompanyAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, criteria);
  return retDocuments;
}

export function useFullIncomeDocumentCompanyCriteria(companyId: string, criteria: Criteria) {
  const retDocuments = listFullIncomeDocumentsByCompanyAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, criteria);
  return retDocuments;
}

export function useFullOutcomeDocumentCompanyCriteria(companyId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullOutcomeDocumentsByCompanyAndCriteria(documentRepository, companyId, criteria);
  return retDocuments;
}

export function useFullIncomeDocumentCompanyClientCriteria(companyId: string, clientId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullIncomeDocumentsByCompanyClientAndCriteria(documentRepository, companyId, clientId, criteria);
  return retDocuments;
}

export function useFullOutcomeDocumentCompanyProviderCriteria(companyId: string, providerId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullOutcomeDocumentsByCompanyProviderAndCriteria(documentRepository, companyId, providerId, criteria);
  return retDocuments;
}

export function useFullDocumentInvoicesBillsCompanyProviderCriteria(companyId: string, providerId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullDocumentsInvoicesBillsByCompanyProviderAndCriteria(documentRepository, companyId, providerId, criteria);
  return retDocuments;
}

export function useFullDocumentCreditsCompanyProviderCriteria(companyId: string, providerId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullDocumentsCreditsByCompanyProviderAndCriteria(documentRepository, companyId, providerId, criteria);
  return retDocuments;
}


export function useFullOutcomeDocumentCompanyCollaboratorCriteria(companyId: string, collaboratorId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullOutcomeDocumentsByCompanyCollaboratorAndCriteria(documentRepository, companyId, collaboratorId, criteria);
  return retDocuments;
}

export function useFullDocumentCompanyEmployeeCriteria(companyId: string, employeeId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullDocumentsByCompanyEmployeeAndCriteria(documentRepository, companyId, employeeId, criteria);
  return retDocuments;
}


export function useFullOutcomeDocumentCompanyEmployeeCriteria(companyId: string, employeeId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const retDocuments = listFullOutcomeDocumentsByCompanyEmployeeAndCriteria(documentRepository, companyId, employeeId, criteria);
  return retDocuments;
}

export async function useSplitFullOutcomeDocumentCompanyEmployeeCriteria(companyId: string, employeeId: string, criteria: Criteria) {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  const [retDocument, retDocument2] = await listSplitFullOutcomeDocumentsByCompanyEmployeeAndCriteria(documentRepository, companyId, employeeId, criteria);
  console.log("retDocument: ", JSON.stringify(retDocument), " retDocument2: ", JSON.stringify(retDocument2));
  return [retDocument, retDocument2];
}



export async function findDocumentBySpotExpenseId(spotExpenseId: string, companyId: string): Promise<Document> {
  const documentRepository = Dependencies.getInstance().getDocumentRepository();
  console.log("dentro de findDocumentBySpotExpenseId: ", spotExpenseId, " companyId: ", companyId);
  const document = await documentRepository.getDocumentBySpotExpenseId(spotExpenseId, companyId);
  return document;
}

export async function useDisableDocument(companyId:string, documentId: string, type: string): Promise<VectiResult> {
  try{
   await disableDocument(Dependencies.getInstance().getDocumentRepository(), companyId, documentId, type);
   return new VectiResult(true, "Error saving employee name");
  }catch(error){
    return new VectiResult(false, "Error al deshabilitar el documento");
  }
 

}




export function useDocumentFullDBCompanySearch(companyId: string, search: string) {
  try {
    console.log("dentro de useDocumentFullDBCompanySearch: companyId: ", companyId, " search", JSON.stringify(search));
    const retDocuments = listDocumentsFullRepositoryByCompanyAndSearch(Dependencies.getInstance().getDocumentRepository(), companyId, search);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFullDBCompanySearch: ", error);
  }
}

export function useDocumentFullDBCompanySearchClient(companyId: string, search: string, clientId:string) {
  try {
    console.log("dentro de useDocumentFullDBCompanySearchClient: companyId: ", companyId, " search", JSON.stringify(search), " clientId: " + clientId);
    const retDocuments = listDocumentsFullRepositoryByCompanySearchAndClient(Dependencies.getInstance().getDocumentRepository(), companyId, search, clientId);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFullDBCompanySearchClient: ", error);
  }
}

export function useDocumentFullDBCompanySearchProviderCriteria(companyId: string, search: string, providerId:string, criteria: Criteria) {
  try {
    console.log("dentro de useDocumentFullDBCompanySearchProviderCriteria: companyId: ", companyId, " search", JSON.stringify(search), " providerId: " + providerId);
    const retDocuments = listDocumentsFullRepositoryByCompanySearchProviderAndCriteria(Dependencies.getInstance().getDocumentRepository(), companyId, search, providerId,criteria);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFullDBCompanySearchProvider: ", error);
  }
}


export function useDocumentFullDBCompanySearchProvider(companyId: string, search: string, providerId:string) {
  try {
    console.log("dentro de useDocumentFullDBCompanySearchProvider: companyId: ", companyId, " search", JSON.stringify(search), " providerId: " + providerId);
    const retDocuments = listDocumentsFullRepositoryByCompanySearchAndProvider(Dependencies.getInstance().getDocumentRepository(), companyId, search, providerId);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFullDBCompanySearchProvider: ", error);
  }
}



export function useDocumentFullCompanyYearMonth(companyId: string, year:number, month:number,criteria: Criteria) {
  console.log("(useDocumentFullCompanyYearMonth): companyId: ", companyId, " criteria", JSON.stringify(criteria), " month:" + month, " year:" + year);
  const yearNum = parseInt(''+year);
  const monthNum = parseInt(''+month);
  console.log("(useDocuments - useDocumentFullCompanyYearMonth) :" + yearNum);
  console.log("(useDocuments - useDocumentFullCompanyYearMonth) monthNum:" + monthNum);
  const retDocuments = listDocumentsFullByCompanyYearMonthAndCriteria(Dependencies.getInstance().getDocumentRepository(),companyId,  yearNum, monthNum, criteria);
  return retDocuments;
}


export function useDocumentFullCompanyYear(companyId: string, year:number, criteria: Criteria) {
  console.log("(useDocumentFullCompanyYear): companyId: ", companyId, " criteria", JSON.stringify(criteria), " year:" + year);
  const yearNum = parseInt(''+year);  
  console.log("(useDocuments - useDocumentFullCompanyYear) :" + yearNum);  
  const retDocuments = listDocumentsFullByCompanyYearAndCriteria(Dependencies.getInstance().getDocumentRepository(),companyId,  yearNum, criteria);
  return retDocuments;
}


export function useDocumentFull(companyId: string,documentId: string, type:string) {
  console.log("dentro de useDocumentFull:" + companyId + " documentId:" +  documentId + " type:" + type);
  const retMovement = getFullDocumentByIdCompanyAndType(Dependencies.getInstance().getDocumentRepository(), companyId, documentId, type);
  return retMovement;
}




export function useDocumentFromBusinessView(companyId: string, documentType:string, year:string, month:string, criteria: Criteria) {
  try {
    console.log("dentro de useDocumentFromBusinessView: companyId:"+ companyId + " documentType:" + documentType);
    const retDocuments = listDocumentsByCompanyTypeYearMonth(Dependencies.getInstance().getDocumentRepository(), companyId, documentType, year, month, criteria);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFromBusinessView: "+ error);
  }

}

export function useIncomeDocumentFromBusinessView(companyId: string, documentType:string, year:string, month:string, criteria: Criteria) {
  try {
    console.log("dentro de useDocumentFromBusinessView: companyId:"+ companyId + " documentType:" + documentType);
    const retDocuments = listIncomeDocumentsByCompanyTypeYearMonth(Dependencies.getInstance().getDocumentRepository(), companyId, documentType, year, month, criteria);
    return retDocuments;
  } catch (error) {
    console.log("error en useDocumentFromBusinessView: "+ error);
  }

}

export async function usePendingInvoices(companyId: string): Promise<VectiResult> {
 try {
    console.log("usePendingInvoices companyId: " + companyId);
    const retInvoices = await listTop10PendingIncomeInvoices(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) usePendingInvoices error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function useOverdueOutcomeInvoices(companyId: string): Promise<VectiResult> {
 try {
    console.log("useOverdueOutcomeInvoices companyId: " + companyId);
    const retInvoices = await listTop10OverdueOutcomeInvoices(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) usePendingInvoices error:" + error);
    return new VectiResult(false, "Error");
  }
}


export async function useFutureOutcomeInvoices(companyId: string): Promise<VectiResult> {
 try {
    console.log("useFutureOutcomeInvoices companyId: " + companyId);
    const retInvoices = await listTop10FutureOutcomeInvoices(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) useFutureOutcomeInvoices error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function useFutureOutcomeDocuments(companyId: string): Promise<VectiResult> {
 try {
    console.log("useFutureOutcomeDocuments companyId: " + companyId);
    const retInvoices = await listTop10FutureOutcomeDocuments(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) useFutureOutcomeDocuments error:" + error);
    return new VectiResult(false, "Error");
  }
}


export async function useFutureIncomeInvoices(companyId: string): Promise<VectiResult> {
 try {
    console.log("useFutureIncomeInvoices companyId: " + companyId);
    const retInvoices = await listTop10FutureIncomeInvoices(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) useFutureIncomeInvoices error:" + error);
    return new VectiResult(false, "Error");
  }
}

export async function useFutureIncomeDocuments(companyId: string): Promise<VectiResult> {
 try {
    console.log("useFutureIncomeDocuments companyId: " + companyId);
    const retInvoices = await listTop10FutureIncomeDocuments(Dependencies.getInstance().getDocumentRepository(), companyId);
    return retInvoices;
  } catch (error) {
    console.log("(useDocuments) useFutureIncomeInvoices error:" + error);
    return new VectiResult(false, "Error");
  }
}


export async function useSaveExpectedPayDate(companyId: string, documentId:string, documentExpectedPayDate:string, documentType:string, documentOrigin:string):  Promise<VectiResult> {
  try{
  await saveExpectedPayDate(
    Dependencies.getInstance().getDocumentRepository(),
    companyId,
    documentId,
    documentExpectedPayDate,
    documentType,
    documentOrigin);
    return new VectiResult(true, {uid:documentId});
  }catch(error){
    return new VectiResult(false, "Error saving expected pay date");
  }  

}



/*
export async function useRemoveDocument(uid: string, type:string, companyId: string): Promise<VectiResult> {
 try {
    console.log("(useRemoveDocument) uid: " + uid + " type:" + type + " companyId: " + companyId);    
    await disableDocument(Dependencies.getInstance().getDocumentRepository(), uid, type,companyId);
    return new VectiResult(true, "{message:" + type + " id " + uid + " removed successfully}");
  } catch (error) {
    console.log("(useRemoveDocument) error:" + error);
    return new VectiResult(false, "Error");
  }
}
*/



